import React from 'react';
import buttonPropTypes from './ButtonProptypes';
import PrimaryButton from './PrimaryButton';

const TertiaryButton = ({ children, customClass = '', disabled, ...rest }) => {
  const disabledStyles = 'opacity-50 cursor-not-allowed pointer-events-none';
  const buttonStyles = `
    bg-transparent !border-0 !text-custom-light-blue 
    ${disabled ? disabledStyles : ''}
    ${customClass}
  `.trim();

  return (
    <PrimaryButton customClass={buttonStyles} {...rest}>
      {children}
    </PrimaryButton>
  );
};

TertiaryButton.propTypes = buttonPropTypes;

export default TertiaryButton;
